import { render } from "./PartsVersionControl.vue?vue&type=template&id=3d35f020"
import script from "./PartsVersionControl.vue?vue&type=script&lang=js"
export * from "./PartsVersionControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__